export const ServiceMedicalType: {
    MEDICAL: 'MEDICAL',
    NOT_MEDICAL: 'NOT_MEDICAL',
} = {
    MEDICAL: 'MEDICAL',
    NOT_MEDICAL: 'NOT_MEDICAL',
};

export type ServiceMedicalType = (typeof ServiceMedicalType)[keyof typeof ServiceMedicalType];

export const getServiceMedicalTypeLabel = (type: ServiceMedicalType): string => {
    switch (type) {
        case ServiceMedicalType.MEDICAL:
            return 'Medizinisch';
        case ServiceMedicalType.NOT_MEDICAL:
            return 'Nicht medizinisch';
        default:
            return 'Unbekannt';
    }
};